<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">State Switch Inputs</h6>
              To implement a switch element in the application, we add the
              component vs-switch.
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <label for="" class="float-left mr-2">true / active</label>
                <vs-switch v-model="switch1" />
              </li>
              <li>
                <label for="" class="float-left mx-2">false / inactive</label>
                <vs-switch v-model="switch2" />
              </li>
              <li>
                <label for="" class="float-left mx-2">disabled / active</label>
                <vs-switch disabled="true" v-model="switch3" />
              </li>
              <li>
                <label for="" class="float-left ml-2"
                  >disabled / inactive</label
                >
                <vs-switch disabled="true" v-model="switch4" />
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color Switch Inputs</h6>
              You can choose the default Switch. You are able to use the Main
              Colors or RGB and HEX colors.
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <label for="" class="float-left mx-2">Primary</label>
                <vs-switch v-model="cswitch1" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Success</label>
                <vs-switch color="success" v-model="cswitch2" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Danger</label>
                <vs-switch color="danger" v-model="cswitch3" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Warning</label>
                <vs-switch color="warning" v-model="cswitch4" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Dark</label>
                <vs-switch color="dark" v-model="cswitch5" />
              </li>
              <li class="con-input-color">
                <label for="" class="float-left mx-2"
                  >Color: <span>{{ color }}</span></label
                >
                <input
                  v-model="color"
                  class="mr-2 float-left ml-2"
                  type="color"
                />
                <vs-switch
                  class="float-left ml-2"
                  :color="color"
                  v-model="cswitch6"
                />
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Text Switch Inputs</h6>
              You can add a descriptive text with the slot on or off. You can
              also join the text with the icons.
            </div>
          </header>
          <div class="vs-card--content">
            <div class="centex md:flex">
              <vs-switch v-model="tswitch1" class="float-left ml-2">
                <span slot="on">On</span>
                <span slot="off">Off</span>
              </vs-switch>
              <vs-switch color="success" v-model="tswitch2" class="float-left ml-2">
                <span slot="on">Accept</span>
                <span slot="off">Cancel</span>
              </vs-switch>
              <vs-switch color="danger" vs-icon-off="close" v-model="tswitch3">
                <span slot="on">Remove</span>
              </vs-switch>
              <vs-switch
                color="warning"
                vs-icon-on="error_outline"
                v-model="tswitch4"
                class="float-left ml-2"
              >
                <span slot="off">Prevent</span>
              </vs-switch>
              <vs-switch
                color="dark"
                vs-icon-on="check_box"
                vs-icon-off="block"
                v-model="tswitch5"
                class="float-left ml-2"
              >
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icon Switch Inputs</h6>
              We can add a representative icon inside our switch with the
              property vs-icon.
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <label for="" class="float-left mr-2">Primary</label>
                <vs-switch
                  v-model="iswitch1"
                  vs-icon-off="notifications_none"
                  vs-icon-on="done"
                />
              </li>
              <li>
                <label for="" class="float-left mx-2">Success</label>
                <vs-switch color="success" v-model="iswitch2" vs-icon="done" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Danger</label>
                <vs-switch color="danger" v-model="iswitch3" vs-icon="close" />
              </li>
              <li>
                <label for="" class="float-left mx-2">Warning</label>
                <vs-switch
                  color="warning"
                  v-model="iswitch4"
                  vs-icon="error_outline"
                />
              </li>
              <li>
                <label for="" class="float-left mx-2">Dark</label>
                <vs-switch
                  color="dark"
                  v-model="iswitch5"
                  vs-icon="volume_off"
                />
              </li>
              <li>
                <label for="" class="float-left mx-2"
                  >rgb(color) / #color</label
                >
                <vs-switch
                  color="rgb(51, 53, 83)"
                  v-model="iswitch6"
                  vs-icon="photo_camera"
                />
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      switch1: true,
      switch2: false,
      switch3: true,
      switch4: false,
      color: "#5a3cc4",
      cswitch1: true,
      cswitch2: true,
      cswitch3: true,
      cswitch4: true,
      cswitch5: true,
      cswitch6: true,
      tswitch1: true,
      tswitch2: true,
      tswitch3: true,
      tswitch4: true,
      tswitch5: true,
      iswitch1: false,
      iswitch2: false,
      iswitch3: false,
      iswitch4: false,
      iswitch5: false,
      iswitch6: false,
    };
  },
};
</script>